import React, { useState, useEffect, useRef, useCallback } from "react";
import { Layout, Table, Input, Button, Form, Space, Popconfirm, Row, Col, Breadcrumb, Modal, message, Typography, Select, Tooltip, Tag, Switch } from "antd";
import Headerdiv from "../../layout/header";
import Footerdiv from "../../layout/footer";
import { 
    PlusOutlined, SearchOutlined, CloseCircleFilled, CheckCircleFilled, 
    EditOutlined, HomeOutlined, UserOutlined 
} from "@ant-design/icons";
import api from "../../../services/axiosInstance";
import dayjs from "dayjs";
import Highlighter from 'react-highlight-words';
import "../../../styles/fluidDesign.css";
const { Content } = Layout;
const ManageUser = () => {

    const [users, setUsers] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
    const [addForm] = Form.useForm();
    const [form] = Form.useForm();
    const [isAddModalVisible, setIsAddModalVisible] = useState(false);

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const UPDATED_BY = localStorage.getItem("USERID");

    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({
                                closeDropdown: false,
                            });
                            setSearchText(selectedKeys[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Filter
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        filterDropdownProps: {
            onOpenChange(open) {
                if (open) {
                    setTimeout(() => searchInput.current?.select(), 100);
                }
            },
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    const fetchUsers = useCallback(async (page = 1, pageSize = 10) => {
        try {
            setLoading(true);
            const response = await api.get(`/settings/user/listall.php?page=${page}&limit=${pageSize}`);
            const mappedUsers = response.data.dataset.map((item) => ({
                userId: item.user_id,
                userName: item.user_name,
                userDisplayName: item.user_dname,
                userEmail: item.user_email,
                userMobile: item.user_mobile,
                userLastupdate: item.user_lastupdate,
                userLastlog: item.user_lastlog,
                userStatus: item.user_status,
                userRoleId: item.role_id,
                userRole: item.role_name,
                userDesiId: item.desi_id,
                //userDesignation: item.desi_name,
            }));

            setUsers(mappedUsers);
            setPagination({
                current: response.data.pagination?.current_page || 1,
                pageSize: response.data.pagination?.per_page || 10,
                total: response.data.pagination?.total_records || 0,
            });

        } catch (error) {
            message.error("Failed to fetch user.");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchUsers(1, 10);
        fetchActiveDesignations();
        fetchActiveRoles();
    }, [fetchUsers]);

    const handleTableChange = (paginationConfig) => {
        fetchUsers(paginationConfig.current, paginationConfig.pageSize);
    };
    const fetchUserDetailsById = async (id) => {
        try {
            const response = await api.get(`/settings/user/detail.php?id=${id}`);
            const item = response.data.dataset;
            setCurrentUser(item);
            form.setFieldsValue({
                userId: item.userid,
                userName: item.username,
                userDisplayName: item.userdname,
                userEmail: item.useremail,
                userMobile: item.usermobile,
                userLastupdate: item.userlastupdate,
                userLastlog: item.userlastlog,
                userstatus: item.userstatus === "1",
                userRole: item.roleid,
               // userDesignation: item.desiid,
            });
            setIsModalVisible(true);
        } catch (error) {
            message.error("Failed to fetch user details.");
        }
    };

    const handleEdit = (record) => {

        fetchUserDetailsById(record.userId);
    };

    const handleUpdate = async (values) => {
        console.log("values---", values);

        // const resolvedDesignationId = isNaN(values.userDesignation) 
        //     ? designations.find(d => d.label === values.userDesignation)?.value || values.userDesignation
        //     : values.userDesignation;
        
        const resolvedRoleId = isNaN(values.userRole)
            ? roles.find(r => r.label === values.userRole)?.value || values.userRole
            : values.userRole;

        const payload = {
            userid: currentUser.userid,
            username: values.userName,
            displayname: values.userDisplayName,
            //designationid: resolvedDesignationId,
            userroleid: resolvedRoleId,
            email: values.userEmail,
            mobile: values.userMobile,
            activestatus: values.userstatus ? "1" : "0",
            updatedby: UPDATED_BY,
        };
        try {
            setLoading(true);
            const response = await api.post("/settings/user/update.php", payload);
            if (response.data.status == "success") {
                message.success(response.data.message || "User updated successfully.");
                setIsModalVisible(false);
                fetchUsers(pagination.current, pagination.pageSize);
                form.resetFields();
            } else {
                throw new Error(response.data.message || "Failed to update user");
            }

        } catch (error) {
            message.error("Failed to update user.");
        } finally {
            setLoading(false);
        }
    };

    const handleAdd = async (values) => {
        // const resolvedDesignationId = isNaN(values.userDesignation) 
        //     ? designations.find(d => d.label === values.userDesignation)?.value || values.userDesignation
        //     : values.userDesignation;
        
        const resolvedRoleId = isNaN(values.userRole)
            ? roles.find(r => r.label === values.userRole)?.value || values.userRole
            : values.userRole;

        const payload = {
            username: values.userName,
            displayname: values.userDisplayName,
            //designationid: resolvedDesignationId,
            userroleid: resolvedRoleId,
            email: values.userEmail,
            mobile: values.userMobile,
            activestatus: values.userStatus ? "1" : "0",
            createdby: UPDATED_BY,
        };

        try {
            setLoading(true);
            const response = await api.post("/settings/user/create.php", payload);
            if (response.data.status == "success") {
                message.success(response.data.message || "User added successfully.");
                setIsAddModalVisible(false);
                fetchUsers(pagination.current, pagination.pageSize);
                addForm.resetFields();
            } else {
                throw new Error(response.data.message || "Failed to add user");
            }

        } catch (error) {
            message.error("Failed to add user. Please try again.");
        } finally {
            setLoading(false);
        }
    };


    const fetchActiveDesignations = async () => {
        try {
            const response = await api.get("/masterdropdown/listof_activedesignations.php");
            setDesignations(response.data.dataset);
        } catch (error) {
            message.error("Failed to fetch departments.");
        }
    };
    const fetchActiveRoles = async () => {
        try {
            const response = await api.get("/masterdropdown/listof_activeusersroles.php");
            setRoles(response.data.dataset);
        } catch (error) {
            message.error("Failed to fetch departments.");
        }
    };

    const columns = [

        {
            title: "Username",
            dataIndex: "userName",
            key: "userName",
            sorter: (a, b) => a.userName.localeCompare(b.userName),
            ...getColumnSearchProps('userName')
        },
        {
            title: "Name",
            dataIndex: "userDisplayName",
            key: "userDisplayName",
            sorter: (a, b) => a.userDisplayName.localeCompare(b.userDisplayName),
            ...getColumnSearchProps('userDisplayName')
        },

        {
            title: "Email",
            key: "userEmail",
            dataIndex: "userEmail",
            ...getColumnSearchProps('userEmail'),
            width: "20%",
        },

        {
            title: "Mobile Number",
            dataIndex: "userMobile",
            key: "userMobile",
            sorter: (a, b) => a.userMobile.localeCompare(b.userMobile),
            ...getColumnSearchProps('userMobile')

        },
        // {
        //     title: "Designation",
        //     dataIndex: "userDesignation",
        //     key: "userDesignation",
        //     sorter: (a, b) => a.userDesignation.localeCompare(b.userDesignation),
        //     ...getColumnSearchProps('userDesignation')
        // },
        {
            title: "Role",
            dataIndex: "userRole",
            key: "userRole",
            sorter: (a, b) => a.userRole.localeCompare(b.userRole),
            ...getColumnSearchProps('userRole')
        },
        {
            title: "Status",
            dataIndex: "userStatus",
            key: "userStatus",
            align: "center",
            width: 100,
            render: (userStatus) =>
                userStatus == 1 ? (
                    <Tooltip title="Active">
                        <Space size={4}>
                            <CheckCircleFilled style={{ color: "green", fontSize: "16px" }} />
                            <Typography.Text style={{ color: "green" }}>Active</Typography.Text>
                        </Space>
                    </Tooltip>
                ) : (
                    <Tooltip title="Inactive">
                        <Space size={4}>
                            <CloseCircleFilled style={{ color: "red", fontSize: "16px" }} />
                            <Typography.Text style={{ color: "red" }}>Inactive</Typography.Text>
                        </Space>
                    </Tooltip>
                ),
        },
        // {
        //     title: "Last Loged",
        //     dataIndex: "userLastlog",
        //     key: "userLastlog",
        //     width: 150,
        //     sorter: (a, b) => a.userLastlog.localeCompare(b.userLastlog),
        //     ...getColumnSearchProps('userLastlog'),
        //     render: (date) => <span>{dayjs(date).format("YYYY-MM-DD")}</span>,
        // },
        {
            title: "Last Updated",
            dataIndex: "userLastupdate",
            key: "userLastupdate",
            width: 150,
            sorter: (a, b) => a.userLastupdate.localeCompare(b.userLastupdate),
            render: (date) => <span>{dayjs(date).format("YYYY-MM-DD")}</span>,
        },
        {
            title: "Action",
            key: "action",
            align: "center",
            fixed: 'right',
            width: 150,
            render: (_, record) => (
                <Space>
                    <Tooltip title="Edit Department">
                        <Button
                            type="text"
                            icon={<EditOutlined />}
                            onClick={() => handleEdit(record)}
                        ></Button>
                    </Tooltip>
                </Space>
            ),
        },
    ];

    return (
        <Layout className="fluid-page">
            <Headerdiv />

            {/* Fluid Page Header */}
            <div className="fluid-page-header">
                <div className="floating-shape shape-1"></div>
                <div className="floating-shape shape-2"></div>
                <Row align="bottom" justify="space-between">
                    <Col>
                                                    <Breadcrumb
                                className="fluid-breadcrumb"
                                items={[
                                    { href: '/dash', title: <HomeOutlined /> },
                                    { title: 'Settings' },
                                    { title: 'User Management' },
                                ]}
                            />
                        <h1 className="fluid-page-title">
                            <UserOutlined /> User Management
                        </h1>
                    </Col>
                    <Col xs={0} md={12} style={{ textAlign: 'right' }}>
                        <p className="fluid-page-subtitle">Manage system users and their access</p>
                    </Col>
                </Row>
            </div>

            <Content className="fluid-content">
                {/* Users Table Card */}
                <div className="fluid-card">
                    <div className="fluid-card-header">
                        <h3 className="fluid-card-title">List of Users</h3>
                        <Space>
                            <Typography.Text type="secondary">{users.length} records</Typography.Text>
                            <Button type="primary" icon={<PlusOutlined />} onClick={() => setIsAddModalVisible(true)}>
                                Add New User
                            </Button>
                        </Space>
                    </div>
                    <div className="fluid-table">
                        <Table
                            size="small"
                            columns={columns}
                            dataSource={users}
                            rowKey="userId"
                            pagination={{
                                current: pagination.current,
                                pageSize: pagination.pageSize,
                                total: pagination.total,
                                showSizeChanger: true,
                                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                            }}
                            onChange={handleTableChange}
                            scroll={{ x: 1000 }}
                            loading={loading}
                        />
                    </div>
                </div>
            </Content>
            <Footerdiv />
            <Modal
                title="Add New User"
                open={isAddModalVisible}
                onCancel={() => { setIsAddModalVisible(false); addForm.resetFields(); }}
                footer={null}
                width={700}
                destroyOnClose
            >
                <Form form={addForm} layout="vertical" onFinish={handleAdd}>
                    <Row gutter={[16, 16]}>
                        <Col xs={24} md={12}>
                            <Form.Item label="Username" name="userName" rules={[
                                { required: true, message: "Please enter a username" },
                                { pattern: /^[a-zA-Z0-9]+$/, message: "Username can only contain letters and numbers" },
                            ]}>
                                <Input placeholder="Enter User Name" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label="Name" name="userDisplayName" rules={[{ required: true, message: "Please enter Name" }]}>
                                <Input placeholder="Enter Name" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label="User Role" name="userRole" rules={[{ required: true, message: "Please Select User Role" }]}>
                                <Select allowClear placeholder="Select User Role">
                                    {roles.map((role) => (
                                        <Select.Option key={role.value} value={role.value}>
                                            {role.label}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item
                                name="userEmail"
                                label="E-mail"
                                rules={[
                                    { type: 'email', message: 'The input is not valid E-mail!' },
                                    { required: true, message: 'Please input your E-mail!' },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item
                                name="userMobile"
                                label="Mobile Number"
                                rules={[
                                    { required: true, message: "Please input your phone number!" },
                                    { pattern: /^7\d{8}$/, message: "Contact must be 9 digits, starting with 7" },
                                ]}
                            >
                                <Input maxLength={9} placeholder="7XXXXXXXX" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item name="userStatus" label="Active" valuePropName="checked" style={{ margin: 0 }}>
                                <Switch />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row justify="end" style={{ marginTop: 16 }}>
                        <Form.Item style={{ marginBottom: 0 }}>
                            <Space>
                                <Button danger onClick={() => { setIsAddModalVisible(false); addForm.resetFields(); }}>Cancel</Button>
                                <Button type="primary" htmlType="submit" icon={<PlusOutlined />} loading={loading}>Add User</Button>
                            </Space>
                        </Form.Item>
                    </Row>
                </Form>
            </Modal>
            <Modal
                title="Edit User Details"
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
            >
                <Form form={form} onFinish={handleUpdate} layout="vertical">

                    <Row>
                        <Col xs={24} md={12}>
                            <Form.Item label="Username" name="userName" rules={[
                                // { required: true, message: "Please enter a username" },
                                // { min: 6, max: 15, message: "Username must be 6-15 characters long" },
                                // { pattern: /^[a-zA-Z]+$/, message: "Username can only contain letters" },
                            ]}
                            >
                                <Input
                                    disabled
                                    placeholder="Enter User Name"
                                    style={{ width: "100%", margin: "0" }}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12} style={{ padding: "0 0 0 5px" }}>
                            <Form.Item
                                label="Name"
                                name="userDisplayName"
                                rules={[{ required: true, message: "Please enter Name" }]}
                            >
                                <Input

                                    placeholder="Enter Name"
                                    style={{ width: "100%", margin: "0" }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        {/* <Col xs={24} md={12}>
                            <Form.Item
                                label="Designation"
                                name="userDesignation"
                                rules={[{ required: true, message: "Please select a designation" }]}
                            >
                                <Select allowClear placeholder="Select Designation">
                                    {designations.map((desi) => (
                                        <Select.Option key={desi.value} value={desi.value}>
                                            {desi.label}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col> */}
                        <Col xs={24} md={12} style={{ padding: "0 0 0 5px" }}>
                            <Form.Item label="User Role" name="userRole" rules={[{ required: true, message: "Please Select User Role" }]}>
                                <Select allowClear placeholder="Select User Role">
                                    {roles.map((role) => (
                                        <Select.Option key={role.value} value={role.value}>
                                            {role.label}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={24} md={12}>
                            <Form.Item
                                name="userMobile"
                                label="Mobile Number"
                                rules={[
                                    { required: true, message: "Please input your phone number!" },
                                    { pattern: /^7\d{8}$/, message: "Contact must be 9 digits, starting with 7" },
                                ]}
                            >
                                <Input

                                    maxLength={9}
                                    placeholder="7XXXXXXXX"
                                    style={{ width: "100%" }}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12} style={{ padding: "0 0 0 5px" }}>

                            <Form.Item
                                name="userEmail"
                                label="E-mail"
                                rules={[
                                    {
                                        type: 'email',
                                        message: 'The input is not valid E-mail!',
                                    },
                                    {
                                        required: true,
                                        message: 'Please input your E-mail!',
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24} md={12}>
                            <Form.Item name="userstatus" label="Active" valuePropName="checked" style={{ padding: "0 0 0 8px" }} >
                                <Switch onChange={(checked) => form.setFieldsValue({ userstatus: checked ? 1 : 0 })} />
                            </Form.Item>
                        </Col>

                    </Row>
                    <Row >
                        {/* <Button type="primary" htmlType="submit" loading={loading} >
                                Update
                            </Button> */}
                        <Form.Item>
                            <Space>
                                <Button type="primary" htmlType="submit" disabled={loading}>
                                    Save Changes
                                </Button>
                                <Button
                                    danger
                                    onClick={() => {
                                        setIsModalVisible(false);

                                        form.resetFields();
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Space>
                        </Form.Item>
                    </Row>

                </Form>
            </Modal>
        </Layout>
    );
};

export default ManageUser;